import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap items-center pt-3 pb-6 text-dark-gray gap-2"
}
const _hoisted_2 = { class: "md:w-full md:mb-4 lg:w-auto lg:mb-0" }
const _hoisted_3 = { class: "font-basier text-sm font-bold mr-3 flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Aktywne filtry: ", -1)
const _hoisted_5 = { class: "ml-2 font-bold text-primary text-lg md:hidden" }
const _hoisted_6 = { class: "flex space-x-1 font-basier text-sm py-1 px-2 bg-primary bg-opacity-20 border border-primary rounded-md items-center md:mb-2 lg:mb-0" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "cursor-pointer text-red opacity-30 h-4 w-4 transition-opacity duration-300 hover:opacity-100",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text-gray font-basier flex items-center" }

import { computed, ref, watchEffect } from 'vue'
import { useFiltersStorage } from '@/composables/useFiltersStorage'
import { UiDotDivider } from '@/components/common/ui'
import { IFilterParam } from '@/types/interfaces/filters'

type Props = {
    activeFilters?: Record<string, string>
    useFilterStorage?: string
    filtersSchema: IFilterParam[]
    clerable?: boolean
}
type Emits = {
    (e: 'removeFilter', value: Record<string, unknown>): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    activeFilters: { type: Object, required: false },
    useFilterStorage: { type: String, required: false },
    filtersSchema: { type: Array, required: true },
    clerable: { type: Boolean, required: false }
  },
  emits: ["removeFilter"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'removeFilter', value: Record<string, unknown>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    activeFilters?: Record<string, string>
    useFilterStorage?: string
    filtersSchema: IFilterParam[]
    clerable?: boolean
}
/* eslint-disable prettier/prettier */




const { currentFilters, updateFilterStorage, clearFilterStorage } = useFiltersStorage(props.useFilterStorage)
const filters = computed<Record<string, string | number>>(() => ({
    ...props.activeFilters,
    ...(props.useFilterStorage && {
        ...(currentFilters.value as Record<string, string | number>),
    }),
}))

const filterMap = ref<Record<string, { value: unknown; label: string }>>({})
watchEffect(() => {
    filterMap.value = {}
    Object.keys(filters.value).forEach(filter => {
        const filterFromSchema = props.filtersSchema.find(_schema => _schema.key === filter)
        const label = filterFromSchema?.label
        const value = filterFromSchema?.options
            ? filterFromSchema?.options.find(opt => opt.id === filters.value[filter])?.name
            : filters.value[filter]

        if (value) filterMap.value[filter] = { value, label: (label as string) }
    })
})

const handleRemoveFilter = (filterKey: string) => {
    const newFilters = { ...filters.value }
    delete newFilters[filterKey]
    delete filterMap.value[filterKey]
    if (props.useFilterStorage) updateFilterStorage(newFilters)
    emit('removeFilter', newFilters)
}

const handleClearFilters = () => {
    filterMap.value = {}
    if (props.useFilterStorage) clearFilterStorage()
    emit('removeFilter', {})
}

const hasFilters = computed(() => Object.keys(filterMap.value).length !== 0)

return (_ctx: any,_cache: any) => {
  return (_unref(hasFilters))
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(Object.keys(filterMap.value).length), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(filterMap.value), (filter, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "hidden md:block"
          }, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(filterMap.value[filter].label) + ": ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(filterMap.value[filter].value), 1),
              (props.clerable)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: ($event: any) => (handleRemoveFilter((filter as string)))
                  }, _hoisted_10, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("li", null, [
          _createElementVNode("label", _hoisted_11, [
            _createVNode(_unref(UiDotDivider), { class: "mx-2" }),
            _createElementVNode("span", {
              class: "text-sm text-dark-gray cursor-pointer transition-colors duration-200 hover:text-red",
              onClick: handleClearFilters
            }, "Usuń filtry")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})